import { FragmentRESTSerializer } from 'ember-data-model-fragments/serializer';

export default class ApplicationSerializer extends FragmentRESTSerializer {}
